import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("trico_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("trico_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(res => {
        setUser(res.data);
        localStorage.setItem("trico_user", JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem("trico_token");
        localStorage.removeItem("trico_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("trico_token", res.data.token);
    localStorage.setItem("trico_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (email, password, name, salon_name = null) => {
    const res = await api.post("/auth/register", { email, password, name, salon_name });
    localStorage.setItem("trico_token", res.data.token);
    localStorage.setItem("trico_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const refreshUser = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      localStorage.setItem("trico_user", JSON.stringify(res.data));
      return res.data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem("trico_token");
    localStorage.removeItem("trico_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, refreshUser, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
